export const BUTTON_INTERACTION_STYLES =
  'transition hover:brightness-95 active:translate-y-px focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50';

export const LINK_INTERACTION_STYLES =
  'transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-1';

export const PRIMARY_ACTION_TEXT_STYLES =
  'text-white hover:text-white focus:text-white focus-visible:text-white';

export const PRIMARY_ACTION_LINK_STYLES =
  `${PRIMARY_ACTION_TEXT_STYLES} visited:text-white`;
